"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.color = {
    black: "#000000",
    white: "#FFFFFF",
    gray10: "#F0F2F5",
    gray20: "#C9D3DC",
    gray30: "#A6B5C4",
    gray40: "#879AAC",
    gray50: "#6E8093",
    gray60: "#57697B",
    gray70: "#445363",
    gray80: "#323E4A",
    gray90: "#212932",
    gray100: "#11151A",
    green10: "#E4FFF7",
    green20: "#A4FDE0",
    green30: "#64F4C6",
    green40: "#2EE0A7",
    green50: "#07B67E",
    green60: "#007751",
    green70: "#004B33",
    green80: "#003524",
    green90: "#002A1D",
    green100: "#00261A",
    purple10: "#F4EFFF",
    purple20: "#DAC7FE",
    purple30: "#C1A0FB",
    purple40: "#AA7DF6",
    purple50: "#9861EC",
    purple60: "#8A4ADD",
    purple70: "#7A37C6",
    purple80: "#6227A3",
    purple90: "#431871",
    purple100: "#1E0A33",
    blue10: "#EBF4FF",
    blue20: "#B9D9FE",
    blue30: "#89BDFB",
    blue40: "#5FA1F6",
    blue50: "#3E85ED",
    blue60: "#2568DF",
    blue70: "#144FCA",
    blue80: "#083AA9",
    blue90: "#02267A",
    blue100: "#001340",
    orange10: "#FFF3E4",
    orange20: "#FBCEA2",
    orange30: "#F4A564",
    orange40: "#E87C2F",
    orange50: "#D85909",
    orange60: "#C14700",
    orange70: "#A43A00",
    orange80: "#7F2C00",
    orange90: "#531C00",
    orange100: "#260D00",
    red10: "#FFEBEE",
    red20: "#FEB9C5",
    red30: "#FB899C",
    red40: "#F65F77",
    red50: "#EC3E59",
    red60: "#DD253F",
    red70: "#C6132C",
    red80: "#A3081D",
    red90: "#710211",
    red100: "#330007",
};
